import { ScoringTypeModalProps } from './types/scoringType';
import DialogModal from '../../components/DialogModal';
import { Box, Button, CircularProgress, TextField } from '@mui/material';
import { StyledButton } from '../Exams/styled';
import MultiValueInput from '../../components/MultiValueInput';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import scoringTypes from '../../apis/scoringTypes';

const AddScoringTypeModal: React.FC<ScoringTypeModalProps> = ({
  fetchData,
  open,
  onClose,
  onApiSuccessAndFailure
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [name, setName] = useState<string>('');
  const [validScores, setValidScores] = useState<string[]>([]);

  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );

  const handleAddScore = useCallback((score: string) => {
    setValidScores((prev) => [...prev, score]);
  }, []);

  const handleRemoveScore = useCallback((indexToRemove: number) => {
    setValidScores((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  }, []);

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    const payload = {
      name,
      validScores: validScores.length === 0 ? null : validScores
    };

    try {
      const response = await scoringTypes.upsertScoringType(
        loggedInUser.school,
        payload
      );
      if (response) {
        fetchData();
        const message = `Scoring type added successfully`;
        onApiSuccessAndFailure(true, message);
      }
    } catch (error: any) {
      onApiSuccessAndFailure(false, error.errors[0].message);
    } finally {
      setIsSubmitting(false);
      setName('');
      setValidScores([]);
    }
  };

  return (
    <>
      <DialogModal
        open={open}
        onClose={onClose}
        title='Add Scoring Type'
        actions={
          <>
            <Button onClick={onClose} color='primary' variant='contained'>
              Cancel
            </Button>
            <StyledButton
              onClick={handleSubmit}
              disabled={isSubmitting || !name.trim()}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color='inherit' />
              ) : (
                'Add'
              )}
            </StyledButton>
          </>
        }
      >
        <Box>
          <TextField
            fullWidth
            id='name'
            name='name'
            label='Scoring Type Name'
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <Box marginTop={2}>
            <MultiValueInput
              values={validScores || []}
              onAddValue={handleAddScore}
              onRemoveValue={handleRemoveScore}
              placeholder='Add valid score and press enter'
              label='Valid Scores'
              validationType='text'
            />
          </Box>
        </Box>
      </DialogModal>
    </>
  );
};

export default AddScoringTypeModal;
